
export * from '../../map-common/__liferay__/index.js';
